const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/projects/touring.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { hasOneOfPermissions } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/projects/touring')({
  preload: false,
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    const hasValidPermission = hasOneOfPermissions(permissions, [{
      permission: 'PROJECTS_TOURING',
      action: 'READ'
    }, {
      permission: 'PROJECTS_TOURING_AS_TOURREP',
      action: 'READ'
    }]);
    if (!hasValidPermission) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async () => window.location.replace(`${process.env.PUBLIC_DREAMHAUS_URL}/projects/touring`),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});